type FooterItem = {
  title: string;
  url: string;
  isExternal?: boolean;
};

type FooterSection = {
  title: string;
  links: FooterItem[];
};

export const platformFooterItems: FooterSection[] = [
  {
    title: "Pollinator Program",
    links: [
      {
        title: "Overview",
        url: "/",
      },
      {
        title: "Support",
        url: "/support",
      },
    ],
  },
  {
    title: "Team",
    links: [
      {
        title: "About us",
        url: "/about",
      },
      {
        title: "Contact",
        url: "/contact",
      },
    ],
  },
  {
    title: "Social",
    links: [
      {
        title: "Instagram",
        url: "https://instagram.com/pollinator_coop",
        isExternal: true,
      },
      {
        title: "LinkedIn",
        url: "https://www.linkedin.com/company/pollinator-coop",
        isExternal: true,
      },
    ],
  },
  {
    title: "Legal",
    links: [
      {
        title: "Terms",
        url: "/terms",
      },
      {
        title: "Privacy",
        url: "/privacy",
      },
    ],
  },
];

export default platformFooterItems;
